module.exports = __webpack_public_path__ + "img/route_receiver_number_1.416b21c8.png";